import React, { useState, useContext } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import './Product.css'
import {
    dateTimeFormatFunction,
    handleRedirectInternal,
    capitalize,
} from '../../../common/components'
import CommonContext from '../../../../product/context/common/commonContext'
import ReportContext from '../../../../product/context/report/reportContext'
import { useHistory } from 'react-router-dom'

const ProductListMobileView = (props) => {
    const [auctionAnchor, setAuctionAnchor] = useState(null)
    const [photosAnchor, setPhotosAnchor] = useState(null)
    const commonContext = useContext(CommonContext)
    const { getAllExportDownload } = useContext(ReportContext)
    const { setBidHistoryValue } = commonContext
    const history = useHistory()
    const handleAuctionClick = (event) => {
        setAuctionAnchor(event.currentTarget)
    }

    const handlePhotosClick = (event) => {
        setPhotosAnchor(event.currentTarget)
    }
    const handleDirection = (data) => {
        handleRedirectInternal(history, `erp/inventory/${data}`)
    }

    const handleBid = (id) => {
        setBidHistoryValue({
            id,
            getBidByAuction: true,
            show_tiebid: props.showTieBid || null,
            proxy: props.showProxyBid ? props.showProxyBid : false,
        })
    }

    const handleClose = () => {
        setAuctionAnchor(null)
        setPhotosAnchor(null)
    }

    const handleExport = (data) => {
        getAllExportDownload({
            action: 'export',
            order: 'asc',
            orderby: '',
            search: 'all',
            filters: {
                auctionid: {
                    value: data,
                    type: 'in',
                    field: 'p.auctionid',
                },
            },
            report: `single_auction_product_management`,
        })
    }
    const [readMore, setReadMore] = useState(false)
    const [expanded, setExpanded] = useState(false)
    const [characterLimit, setCharacterLimit] = useState(140)
    const data = props.data
    return (
        <div className="productListView product-list-mobile">
            <div className="media">
                <div className="media-left">
                    <a
                        className="plvLt cursorDecoy"
                        onClick={() =>
                            handleRedirectInternal(history, `erp/${data.id}`)
                        }
                    >
                        <img
                            src={`${global.site_url}/uploads/auction/${data.avatar}`}
                            onError={(e) =>
                                (e.target.src = '/assets/images/noImg.png')
                            }
                            alt=""
                        />
                    </a>
                </div>
                <div className="media-body">
                    <h4
                        className="cursorDecoy list-pro-title"
                        onClick={() =>
                            handleRedirectInternal(history, `erp/${data.id}`)
                        }
                    >
                        {data.title}
                    </h4>
                    <p className="pro-status-xs">
                        <b>Status:</b>
                        {capitalize(data.market_status)}{' '}
                    </p>
                    <a
                        className="cursorDecoy expand-pro-details"
                        onClick={() => setExpanded(!expanded)}
                    >
                        <i className="material-icons">
                            {expanded
                                ? 'keyboard_arrow_up'
                                : 'keyboard_arrow_down'}
                        </i>
                    </a>
                </div>
            </div>

            {expanded ? (
                <div className="productview-details">
                    <div className="plvDet">
                        {!props.noLocation ? (
                            <p>
                                <span>Location:</span>
                                {data.location}{' '}
                            </p>
                        ) : null}

                        <p>
                            <span>Start date:</span>
                            {dateTimeFormatFunction(data.date_added)}{' '}
                        </p>
                        <p>
                            <span>End date:</span>
                            {dateTimeFormatFunction(data.date_closed)}{' '}
                        </p>
                        {!props.noType ? (
                            <p>
                                <span>Auction type:</span>
                                Timed Auction
                            </p>
                        ) : null}

                        <p>
                            <span>Item count:</span> {data.projectcount}{' '}
                        </p>
                    </div>

                    <div className="plvMeter">
                        <div>
                            <label htmlFor="photos">
                                <span>Photos</span>
                                <span>
                                    {data.project_imagecount}/
                                    {data.projectcount}
                                </span>{' '}
                            </label>
                            <progress
                                id="photos"
                                value={data.project_imagecount}
                                max={data.projectcount}
                            ></progress>
                        </div>
                        <div>
                            <label htmlFor="description">
                                <span>Description</span>
                                <span>
                                    {data.project_desccount}/{data.projectcount}
                                </span>{' '}
                            </label>
                            <progress
                                id="description"
                                value={data.project_desccount}
                                max={data.projectcount}
                            ></progress>
                        </div>
                    </div>
                    <div className="plvDesc">
                        <p className={`${readMore ? 'show' : ''}`}>
                            {data.description.substring(
                                0,
                                readMore
                                    ? data.description.length
                                    : characterLimit
                            )}
                            {!readMore &&
                            data.description.length > characterLimit
                                ? '...'
                                : null}
                        </p>
                        {data.description.length > characterLimit && (
                            <a
                                className="readMore cursorDecoy"
                                onClick={() => setReadMore(!readMore)}
                            >
                                Read {readMore ? 'less' : 'more'}
                            </a>
                        )}
                    </div>
                    <div className="product-details">
                        <div className="plvRtAct">
                            {data.market_status === 'draft' ? (
                                <Button
                                    onClick={() =>
                                        props.onSelectMultiProducts(
                                            data.id,
                                            'draft'
                                        )
                                    }
                                >
                                    Move to live
                                </Button>
                            ) : null}
                            <Button onClick={() => handleExport(data.id)}>
                                Export
                            </Button>
                            <Button
                                aria-controls="simple-menu"
                                aria-haspopup="true"
                                onClick={handleAuctionClick}
                            >
                                Auction{' '}
                                <span className="material-icons">
                                    chevron_right
                                </span>
                            </Button>
                            <Menu
                                id="simple-menu"
                                anchorEl={auctionAnchor}
                                keepMounted
                                open={Boolean(auctionAnchor)}
                                onClose={handleClose}
                            >
                                {data.market_status !== 'closed' ? (
                                    <>
                                        <MenuItem
                                            onClick={() =>
                                                props.function(
                                                    true,
                                                    'edit',
                                                    data.id
                                                )
                                            }
                                        >
                                            Edit Auction
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() =>
                                                handleDirection(data.id)
                                            }
                                        >
                                            Manage Auction
                                        </MenuItem>
                                        {!props.noShowBid ? (
                                            <MenuItem
                                                onClick={() =>
                                                    handleBid(data.id)
                                                }
                                            >
                                                Bid History
                                            </MenuItem>
                                        ) : null}
                                    </>
                                ) : (
                                    <>
                                        {!props.noShowBid ? (
                                            <MenuItem
                                                onClick={() =>
                                                    handleBid(data.id)
                                                }
                                            >
                                                Bid History
                                            </MenuItem>
                                        ) : null}
                                    </>
                                )}
                            </Menu>
                            {data.market_status !== 'closed' ? (
                                <>
                                    <Button
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        onClick={handlePhotosClick}
                                    >
                                        Photos{' '}
                                        <span className="material-icons">
                                            chevron_right
                                        </span>
                                    </Button>
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={photosAnchor}
                                        keepMounted
                                        open={Boolean(photosAnchor)}
                                        onClose={handleClose}
                                    >
                                        <MenuItem
                                            onClick={() =>
                                                props.toggleBulkImagePopup(true)
                                            }
                                        >
                                            Upload Photos
                                        </MenuItem>
                                        {!props.noauction_image ? (
                                            <MenuItem
                                                onClick={() =>
                                                    props.function(
                                                        true,
                                                        'edit',
                                                        data.id
                                                    )
                                                }
                                            >
                                                Manage Photos
                                            </MenuItem>
                                        ) : null}
                                    </Menu>
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}

export default ProductListMobileView
